export type Page =
  'home' | 'invite' | 'print' | 'mockups' | 'privacy' | 'terms' | 'support' | 'not-found';

export function resolvePage(pathname: string): Page {
  if (pathname === '/') return 'home';
  if (pathname === '/invite' || pathname.startsWith('/invite/')) return 'invite';
  if (pathname === '/print' || pathname === '/print/') return 'print';
  if (pathname === '/mockups') return 'mockups';
  if (pathname === '/privacy') return 'privacy';
  if (pathname === '/terms') return 'terms';
  if (pathname === '/support' || pathname === '/support/') return 'support';
  return 'not-found';
}

export function readInviteToken(location: Pick<Location, 'pathname' | 'search'>): string | null {
  const pathToken = location.pathname.startsWith('/invite/')
    ? decodeURIComponent(location.pathname.slice('/invite/'.length))
    : null;
  const queryToken = new URLSearchParams(location.search).get('token');
  const token = pathToken || queryToken;
  return token && token.length >= 32 && token.length <= 1024 ? token : null;
}
